import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';

import Theuz from './theuz/theuz';
import Agenda from './agenda/agenda';
import Reserva from './reserva/reserva';
import Banner from './TheuzBanner/theuzBanner';
import Policy from './pp/policy';
import Portifolio from './portifolio/portifolio';
import Terms from './p-t/terms';
import Privacy from './p-t/privacy';

function App() {

  return (
    <div>
      
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Theuz/>}/>
          <Route path='/agenda' element={<Agenda/>} />
          <Route path='/reserva' element={<Reserva />} />
          <Route path='/bann' element={<Banner />} />      
          <Route path='/policy' element={<Policy />} />      
          <Route path='/portifolio' element={<Portifolio />} />
          <Route path='/terms' element={<Terms />} />
          <Route path='/privacy' element={<Privacy />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
};

export default App;
